export default "__VITE_ASSET__Ckz1UWmJ__"